var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.zurueck()}}},[_vm._v(_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }